<template>
  <el-drawer class="drawer fs-drawer fs-credit-drawer fs-bg-wh" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" :size="(drawerData.editType == 2) ? '60%' : '80%'"
    direction="btt">
    <!-- Drawer Cash -->
    <el-row v-if="status && !confirm && drawerData.paymentType == 1 && drawerData.editType != 2" class="fs-site mt-2">
      <el-col class="text-center mb-2">
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.order') }} #{{ drawerData.orderCode }} {{ $t('drawer.editorder.edit') }} </label><br>
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.recheck') }}</label>
      </el-col>
      <el-col>
        <el-row class="fs-bd-b py-2">
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3--med cl-brown-ligth">{{ drawerData.origTotalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <el-row class="fs-bd-b py-2">
          <el-col :span="12">
            <label class="text-heading3--bold fs-link">{{ $t('drawer.editorder.newprice') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3--bold fs-link"> {{ drawerData.totalAmount | priceFormat(0,currency) }}</label><br>
            <label v-if="Number(drawerData.origTotalAmount) < Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">+ {{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</em></label>
            <label v-if="Number(drawerData.origTotalAmount) > Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">- {{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</em></label>
            <label v-if="Number(drawerData.origTotalAmount) == Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.nondiff1') }}</label>
          </el-col>
        </el-row>
        <el-row class="fs-bd-b py-2">
          <el-col :span="7">
            <label class="text-subtitle--med cl-gray-ligth-sec">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col class="text-right" :span="17">
            <img src="@/assets/icons/thank/cash.png" class="icon-from">
            <label class="text-subtitle--med cl-brown-ligth">{{ $t('pageCheckout.cod') }}</label>
          </el-col>
        </el-row>
        <el-row v-if="true" class="py-2">
          <el-col :span="12">
            <label v-if="drawerData.orderTypeDesc == 'Pickup'" class="text-subtitle--med cl-brown-ligth">{{ $t('pageCheckout.cod') }}</label>
            <label v-else class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.deliverytime') }}</label>
          </el-col>
          <el-col class="text-right" :span="12">
            <label class="text-subtitle--med cl-brown-ligth">{{ drawerData.orderedTime.date }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-row>
          <el-col :span="11">
            <el-button class="text-button fs-btn-border-info" @click="redirectConfirmOrder(drawerData.orderId)">{{ $t('drawer.editorder.confirmorder') }}</el-button>
          </el-col>
          <el-col :span="2">
            <label></label>
          </el-col>
          <el-col :span="11">
            <el-button class="text-button fs-confirm"  @click="confirmEditOrder(drawerData.orderId)">{{ $t('dialog.confirm') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- Drawer Cash Edit Order Success -->
    <el-row v-if="status && confirm && drawerData.paymentType == 1 && drawerData.editType != 2" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col class="text-center">
        <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.orderalready') }}</label>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="redirectOrderDetail(drawerData.orderId)">{{ $t('dialog.close') }}</el-button>
      </el-col>
    </el-row>
    <!-- Drawer Transfer -->
    <el-row v-if="status && !confirm && drawerData.isPaid == 0 && drawerData.paymentType == 2 && drawerData.editType != 2" class="fs-site mt-2">
      <el-col class="text-center mb-2">
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.order') }} #{{ drawerData.orderCode }} {{ $t('drawer.editorder.edit') }} </label><br>
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.recheck') }}</label>
      </el-col>
      <el-col>
        <el-row class="fs-bd-b py-2">
          <el-col :span="8">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
          </el-col>
          <el-col :span="16" class="text-right">
            <label class="text-heading3--med cl-brown-ligth">{{ drawerData.origTotalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <el-row class="fs-bd-b py-2">
          <el-col :span="8">
            <label class="text-heading3--bold fs-link">{{ $t('drawer.editorder.newprice') }}</label>
          </el-col>
          <el-col :span="16" class="text-right">
            <label class="text-heading--bold fs-link">{{ drawerData.totalAmount | priceFormat(0,currency) }}</label><br>
            <label v-if="Number(drawerData.origTotalAmount) < Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">+ {{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</em></label>
            <label v-if="Number(drawerData.origTotalAmount) > Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.different') }} <em class="fs-price-diff">- {{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</em></label>
            <label v-if="Number(drawerData.origTotalAmount) == Number(drawerData.totalAmount)" class="text-subtitle cl-gray-ligth-thrd">{{ $t('drawer.editorder.nondiff2') }}</label>
          </el-col>
        </el-row>
        <el-row class="py-2 fs-bd-b">
          <el-col :span="7">
            <label class="text-subtitle--med cl-gray-ligth-four">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col class="text-right" :span="17">
            <img class="fs-circle fs-al-sb" width="20" height="20" :src="'https://images.foodstory.co/'+ drawerData.payment[0].image_key">
            <label class="text-subtitle--med cl-brown-ligth-sec">{{ $t('drawer.editorder.transfer') }} {{ drawerData.payment[0].bank_name }}</label>
          </el-col>
        </el-row>
        <el-row v-if="true" class="py-2">
          <el-col :span="12">
            <label v-if="drawerData.orderTypeDesc == 'Pickup'" class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.pickuptime') }}</label>
            <label v-else class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.deliverytime') }}</label>
          </el-col>
          <el-col class="text-right" :span="12">
            <label class="text-subtitle--med cl-brown-ligth">{{ drawerData.orderedTime.date }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-row>
          <el-col :span="11">
            <el-button class="text-button fs-btn-border-info" @click="redirectConfirmOrder(drawerData.orderId)">{{ $t('drawer.editorder.confirmorder') }}</el-button>
          </el-col>
          <el-col :span="2">
            <label></label>
          </el-col>
          <el-col :span="11">
            <el-button class="text-button fs-confirm"  @click="confirmEditOrder(drawerData.orderId)">{{ $t('dialog.confirm') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="status && !confirm && drawerData.isPaid == 1 && drawerData.paymentType == 2 && drawerData.editType != 2" class="fs-site mt-2">
      <el-col class="text-center mb-2">
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.order') }} #{{ drawerData.orderCode }} {{ $t('drawer.editorder.edit') }} </label><br>
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.recheck') }}</label>
      </el-col>
      <el-col>
        <el-row class="fs-bd-b py-2">
          <el-col :span="8">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.pricebeforeedit') }}</label>
          </el-col>
          <el-col :span="16" class="text-right">
            <em v-if="drawerData.refundStatus == 0" class="fs-price-success">{{ $t('drawer.editorder.paid') }}</em>
            <label class="text-heading3--med cl-brown-ligth">{{ drawerData.origTotalAmount | priceFormat(0,currency) }}</label><br>
            <img class="fs-circle fs-al-sb" width="20" height="20" :src="'https://images.foodstory.co/'+ drawerData.payment[0].image_key">
            <label class="text-body cl-gray-ligth-sec">{{ $t('drawer.editorder.transfer') }} {{ drawerData.payment[0].bank_name }}</label>
          </el-col>
          <el-col :span="8">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.newprice') }}</label>
          </el-col>
          <el-col :span="16" class="text-right">
            <label class="text-heading3--med cl-brown-ligth">{{ drawerData.totalAmount | priceFormat(0,currency) }}</label><br>
          </el-col>
        </el-row>
        <!-- ชำระเงินเพิ่ม -->
        <el-row v-if="drawerData.isPaid == 1 && Number(drawerData.origTotalAmount) < Number(drawerData.totalAmount)" class="fs-bd-b py-2">
          <el-col :span="12">
            <label class="text-heading3--bold fs-link">{{ $t('drawer.editorder.paymore') }} </label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3--bold fs-link">{{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</label><br>
          </el-col>
        </el-row>
        <!-- คืนเงิน -->
        <el-row v-if="drawerData.isPaid == 1 && Number(drawerData.origTotalAmount) > Number(drawerData.totalAmount)" class="fs-bd-b py-2">
          <el-col :span="12">
            <label class="text-heading3--bold fs-refund">{{ $t('drawer.editorder.refund') }} </label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-heading3--bold fs-refund">{{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</label><br>
          </el-col>
        </el-row>
        <el-row v-if="drawerData.isPaid == 1 && Number(drawerData.origTotalAmount) > Number(drawerData.totalAmount)" class="py-2">
          <el-col>
            <label class="text-subtitle cl-gray-ligth">*{{ $t('drawer.editorder.refundtext') }}</label>
          </el-col>
        </el-row>
        <!-- ไม่มีส่วนต่าง -->
        <el-row v-if="drawerData.isPaid == 1 && Number(drawerData.origTotalAmount) == Number( drawerData.totalAmount)" class="fs-bd-b py-2">
          <el-col class="text-center">
            <label class="text-heading2--med fs-link">{{ $t('drawer.editorder.descriptnondiff1') }} </label>
          </el-col>
        </el-row>
        <el-row v-if="true" class="py-2">
          <el-col :span="12">
            <label v-if="drawerData.orderTypeDesc == 'Pickup'" class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.pickuptime') }}</label>
            <label v-else class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.deliverytime') }}</label>
          </el-col>
          <el-col class="text-right" :span="12">
            <label class="text-subtitle--med cl-brown-ligth">{{ drawerData.orderedTime.date }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-row>
          <el-col :span="11">
            <el-button class="text-button fs-btn-border-info" @click="redirectConfirmOrder(drawerData.orderId)">{{ $t('drawer.editorder.confirmorder') }}</el-button>
          </el-col>
          <el-col :span="2">
            <label></label>
          </el-col>
          <el-col :span="11">
            <el-button class="text-button fs-confirm"  @click="confirmEditOrder(drawerData.orderId)">{{ $t('dialog.confirm') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- Drawer Transfer Edit Order Success -->
    <!-- Pay More -->
    <el-row v-if="status && confirm && drawerData.isPaid == 0 && drawerData.paymentType == 2 && drawerData.editType != 2 && Number(drawerData.origTotalAmount) < drawerData.totalAmount" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col>
        <el-row>
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-title--large cl-brown-ligth">{{ drawerData.totalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="confirmPaymentTransfer(drawerData.orderId)">{{ $t('drawer.editorder.payment') }}</el-button>
      </el-col>
    </el-row>
     <!-- Refund -->
    <el-row v-if="status && confirm && drawerData.isPaid == 0 && drawerData.paymentType == 2 && drawerData.editType != 2 && Number(drawerData.origTotalAmount) > drawerData.totalAmount" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col>
        <el-row>
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-title--large cl-brown-ligth">{{ drawerData.totalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="confirmPaymentTransfer(drawerData.orderId)">{{ $t('drawer.editorder.payment') }}</el-button>
      </el-col>
    </el-row>
    <!-- Not Diff -->
    <el-row v-if="status && confirm && drawerData.isPaid == 0 && drawerData.refundStatus != 3 && drawerData.editType != 2 && drawerData.paymentType == 2 && Number(drawerData.origTotalAmount) == Number(drawerData.totalAmount)" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.orderalready') }}</label>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="closeConfirmOrder">{{ $t('dialog.close') }}</el-button>
      </el-col>
    </el-row>
    <el-row v-if="status && confirm && drawerData.isPaid == 0 && drawerData.refundStatus == 3 && drawerData.editType != 2 && drawerData.paymentType == 2 && Number(drawerData.origTotalAmount) == Number(drawerData.totalAmount)" class="fs-site mt-2">
      <el-col class="text-center">
          <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
        </el-col>
        <el-col class="text-center mb-2">
          <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
          <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
        </el-col>
        <el-col>
          <el-row>
            <el-col :span="12">
              <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
            </el-col>
            <el-col :span="12" class="text-right">
              <label class="text-title--large cl-brown-ligth">{{ drawerData.totalAmount | priceFormat(0,currency) }}</label>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="fs-credit-footer mt-2">
          <el-button class="text-button fs-confirm" @click="confirmPaymentTransfer(drawerData.orderId)">{{ $t('drawer.editorder.payment') }}</el-button>
        </el-col>
    </el-row>
    <!-- Pay More -->
    <el-row v-if="status && confirm && drawerData.isPaid == 1 && drawerData.paymentType == 2 && drawerData.editType != 2 && Number(drawerData.origTotalAmount) < Number(drawerData.totalAmount)" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col>
        <el-row>
          <el-col :span="12">
            <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.totalprice') }}</label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="text-title--large cl-brown-ligth">{{ drawerData.diffTotalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="confirmPaymentTransfer(drawerData.orderId)">{{ $t('drawer.editorder.payment') }}</el-button>
      </el-col>
    </el-row>
    <!-- Refund -->
    <el-row v-if="status && confirm && drawerData.isPaid == 1 && drawerData.paymentType == 2 && drawerData.editType != 2 && Number(drawerData.origTotalAmount) > Number(drawerData.totalAmount)" class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.orderalready') }}</label>
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading3 cl-black-ligth">{{ $t('drawer.editorder.refundtext') }}</label>
        <!-- <label class="text-heading3 cl-black-ligth">*ร้านจะดำเนินการคืนเงินให้กับท่าน</label><br>
        <label class="text-heading3 cl-black-ligth">ภายใน 3 วันทำการ</label> -->
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="closeConfirmOrder">{{ $t('dialog.close') }}</el-button>
      </el-col>
    </el-row>
    <!-- Not Diff -->
    <el-row v-if="
      status && confirm && drawerData.isPaid == 1 && drawerData.paymentType == 2 && drawerData.editType != 2 && Number(drawerData.origTotalAmount) == Number(drawerData.totalAmount) ||
      status && confirm && drawerData.deliveryStatus == 2 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2 ||
      status && confirm && drawerData.deliveryStatus == 9 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2 ||
      status && confirm && drawerData.deliveryStatus == 3 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2 "
    class="fs-site mt-2">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/confirm.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.editpass') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.success') }}</label>
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading3 cl-brown-ligth">{{ $t('drawer.editorder.orderalready') }}</label>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="closeConfirmOrder">{{ $t('dialog.close') }}</el-button>
      </el-col>
    </el-row>
    <!-- Drawer Stamp Edit Order Fail -->
    <el-row v-if="!confirm && !status && drawerData.editType != 2" class="fs-site mt-5">
      <el-col class="text-center">
        <img width="60" height="60" class="ico" src="@/assets/icons/thank/fail.png">
      </el-col>
      <el-col class="text-center mb-2">
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.error1') }}</label><br>
        <label class="text-heading2--med cl-black-ligth">{{ $t('drawer.editorder.error2') }}</label>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-button class="text-button fs-confirm" @click="closeConfirmOrder">{{ $t('dialog.close') }}</el-button>
      </el-col>
    </el-row>
    <!-- Edit Order Time -->
    <el-row v-if="
      status && !confirm && drawerData.deliveryStatus == 3 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2 ||
      status && !confirm && drawerData.deliveryStatus == 9 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2 ||
      status && !confirm && drawerData.deliveryStatus == 2 && drawerData.confirmEditFlag == 0 && drawerData.editType == 2
    " class="fs-site mt-5">
      <el-col class="text-center mb-2">
        <label class="text-heading2--med fs-warning">{{ $t('drawer.editorder.order') }} #{{ drawerData.orderCode }} {{ $t('drawer.editorder.edit') }} </label><br>
        <label v-if="drawerData.orderTypeDesc == 'Pickup'" class="text-heading2--med fs-warning">{{ $t('drawer.editorder.pickuptime') }}</label>
        <label v-else class="text-heading2--med fs-warning">{{ $t('drawer.editorder.deliverytime') }}</label>
      </el-col>
      <el-col class="text-center mt-2">
        <label v-if="drawerData.orderTypeDesc == 'Pickup'" class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.pickuptime') }}</label>
        <label v-else class="text-subtitle--med cl-brown-ligth">{{ $t('drawer.editorder.deliverytime') }}</label>
        <br>
        <label class="text-heading2--med cl-black-ligth">{{ drawerData.orderedTime.date }}</label>
      </el-col>
      <el-col class="fs-credit-footer mt-2">
        <el-row>
          <el-col :span="11">
            <el-button class="text-button fs-btn-border-info" @click="redirectConfirmOrder(drawerData.orderId)">{{ $t('drawer.editorder.confirmorder') }}</el-button>
          </el-col>
          <el-col :span="2">
            <label></label>
          </el-col>
          <el-col :span="11">
            <el-button class="text-button fs-confirm"  @click="confirmEditOrder(drawerData.orderId)">{{ $t('dialog.close') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-drawer>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Mixins from '@/utils/mixins'

export default {
  name: 'DrawerEditOrder',
  props: ['restaurant_uuid', 'branch_uuid', 'drawerData', 'confirm', 'status', 'page', 'index'],
  mixins: [Mixins],
  data() {
    return {
      is_open: true,
      currency: this.$store.getters.currency
    }
  },
  methods: {
    redirectConfirmOrder (orderId) {
      if (this.drawerData.editType == 2) {
        this.$store.dispatch('setConfirmEditOrder', {
          restaurant_uuid: this.BranchDetail.restaurantId,
          branch_uuid: this.BranchDetail.id,
          orderId: orderId
        })
      }
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/confirmorder`, query: { oid: orderId } })
    },
    redirectOrderDetail (orderId) {
      // Send Confirm Edit Order
      this.$emit('toggle_edit_order', { orderDetail: this.drawerData, status:'show' })
    },
    closeConfirmOrder () {
      this.$emit('toggle_edit_order', { orderDetail: this.drawerData, status:'show' })
    },
    confirmEditOrder (orderId) {
      this.$store.dispatch('setConfirmEditOrder', {
        restaurant_uuid: this.BranchDetail.restaurantId,
        branch_uuid: this.BranchDetail.id,
        orderId: orderId
      }).then((response) => {
        if(response) {
          this.confirm = true
          this.status = true
          // Close Edit Order Time
          if (this.drawerData.editType == 2) { this.closeConfirmOrder() }
        } else {
          this.status = false
          this.confirm = false
          // Close Edit Order Time
          if (this.drawerData.editType == 2) { this.closeConfirmOrder() }
        }
      })
    },
    confirmPaymentTransfer (orderId) {
      this.$emit('toggle_edit_order', { orderDetail: this.drawerData, status: 'hide' })
      this.$emit('toggle_edit_order_transfer', this.index)
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    }
  },
  watch:{
    is_open (value) {
      this.$emit('toggle_edit_order', { orderDetail: this.drawerData, status: 'hide' })
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/order/DrawerEditOrder.vue